
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/success",
      function () {
        return require("private-next-pages/quick-purchase/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-purchase/success"])
      });
    }
  